import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class Account extends Vue {
	@Prop() public isVisible!: boolean;
	@Prop() public name!: string;
	@Emit('account-click')
	public async onAccountClickEvent(e: Event): Promise<void> {}

	private async onAccountClick(e: Event): Promise<void> {
		this.onAccountClickEvent(e);
	}
}
